import { createStyles, makeStyles } from "@material-ui/core";
const FTLTableCellStyles = makeStyles((theme) => createStyles({
    basic: ({ textAlign, isDisabled, maxWidth, noCellBorder, minWidth, width, height, }) => (Object.assign({ padding: 8, verticalAlign: "middle", whiteSpace: "pre-wrap", wordBreak: "break-word", textAlign,
        maxWidth,
        minWidth, minHeight: 40, height,
        width, color: isDisabled
            ? theme.palette.text.disable
            : theme.palette.text.primary, outline: "none", transition: !noCellBorder ? theme.transitions.create("box-shadow") : "", backgroundColor: theme.palette.cell.default, background: "none" }, theme.typography.listItemText)),
    head: ({ textAlign = "left", isFocusable, noCellBorder, minWidth, maxWidth, width, }) => {
        const styles = Object.assign({ color: theme.palette.text.tertiary, padding: 8, margin: 0, textAlign,
            minWidth,
            maxWidth,
            width, outline: "none", verticalAlign: "middle", backgroundColor: theme.palette.cell.default }, theme.typography.h5);
        if (isFocusable)
            return Object.assign(Object.assign({}, styles), { "&:hover": {
                    backgroundColor: theme.palette.cell.tableHover,
                }, "&:active": {
                    backgroundColor: theme.palette.cell.tableSelected,
                }, "&:focus": {
                    backgroundColor: theme.palette.cell.default,
                    boxShadow: !noCellBorder
                        ? `inset 0 0 0 2px ${theme.palette.border.focus} !important`
                        : "",
                } });
        return styles;
    },
}));
export default FTLTableCellStyles;
//# sourceMappingURL=FTLTableCellStyles.styles.js.map